/* ConfigLineComponent.js */

"use strict";
const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const Renderer = require("./ConfigLineRenderer");
const FullTextComponent = require("../../veil/fullText/FullTextComponent");

class ConfigLineComponent extends DefaultColumnComponent {
    constructor(value, context) {
        super(value, context);
        this._value = value;
        this._context = context;
        this._resultEntityDef = context.resultEntityDef;
        this._activeOrgId = _.get(this._context.userSession._activeOrganization, "id");
        this._userFeedback = _.get(context, "userFeedback");
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._value = undefined;
        this._activeOrgId = undefined;
        this._userFeedback = undefined;
        return prom;
    }

    /******************************************/
    /* START PUBLIC API METHODS               */
    /******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setLinks(newVal);
        }
    }
    setLinks(newVal) {
        this._value = newVal;
        this.emit("Links", newVal);
    }

    getValue() {
        return this.getLinks();
    }
    getLinks() {
        return this._value;
    }

    openFullText(text) {
        if (!this._userFeedback) {
            return Promise.resolve();
        }
        return this._userFeedback
            .displayCustom(new FullTextComponent(text, "Config Lines"), {notDismissable: false})
            .catch(() => {
                // Dismissing the veil rejects with {userRejected: true}; nothing to do.
            });
    }

    getConfigLine() {
        let configline = this._value.getConfigLines() || [];
        return configline;
    }
    /******************************************/
    /* END PUBLIC API METHODS                 */
    /******************************************/
}

module.exports = ConfigLineComponent;
